export const OFENSIVA = 'Ofensiva';
export const DEFENSIVA = 'Defensiva';
export const CONFRONTO = 'Confronto';
export const REFORCO = 'Reforço';
export const ESTRATEGIAS = [
    OFENSIVA,
    DEFENSIVA,
    CONFRONTO,
    REFORCO
];